import { Component } from '@angular/core';
import { App, ViewController } from 'ionic-angular';

import { NavController } from 'ionic-angular';
import { SignupPage } from '../signup/signup';
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html'
})
export class WelcomePage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(
      public navCtrl: NavController,
      public viewCtrl: ViewController,
      public appCtrl: App ) {
  }
  goToSignup(params){
    if (!params) params = {};
    //this.navCtrl.setRoot(SignupPage);
    this.navCtrl.push(SignupPage);
  }
  goToLogin(params){
    if (!params) params = {};
    this.navCtrl.push(LoginPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts